import { Directive, ElementRef, HostListener, OnInit, Input } from "@angular/core";

@Directive({
  selector: "[appTrapFocus]",
  standalone: false,
})
export class TrapFocusDirective implements OnInit {
  private firstFocusableElement: HTMLElement | null = null;
  private lastFocusableElement: HTMLElement | null = null;
  private focusableElements: HTMLElement[] = [];
  @Input() show: boolean = false;

  constructor(private el: ElementRef) {}

  ngOnInit() {
    this.setFocusableElements();
  }

  ngOnChanges() {
    if (this.show) {
      // Wait for DOM to update
      setTimeout(() => {
        this.setFocusableElements();
        this.firstFocusableElement?.focus();
      });
    }
  }

  private setFocusableElements() {
    const focusableElements = this.el.nativeElement.querySelectorAll(`
      a[href], button:not([disabled]), textarea:not([disabled]),
      input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])
    `);

    this.focusableElements = Array.from(focusableElements) as HTMLElement[];
    this.firstFocusableElement = this.focusableElements[0];
    this.lastFocusableElement = this.focusableElements[this.focusableElements.length - 1];
  }

  @HostListener("document:keydown.tab", ["$event"])
  @HostListener("document:keydown.shift.tab", ["$event"])
  handleTab(event: KeyboardEvent) {
    if (!this.el.nativeElement.contains(document.activeElement)) {
      event.preventDefault();
      this.firstFocusableElement?.focus();
      return;
    }

    if (event.target === this.lastFocusableElement && !event.shiftKey) {
      event.preventDefault();
      this.firstFocusableElement?.focus();
    } else if (event.target === this.firstFocusableElement && event.shiftKey) {
      event.preventDefault();
      this.lastFocusableElement?.focus();
    }
  }
}
